import { map, uniq } from 'lodash';
import { spotifyDiscoveryConstants } from '../constants/spotify_discovery';
import { spotifyDiscoveryService } from '../services/spotify_discovery';
import { tracksService } from '../services/tracks';
import { spotifyDiscoveryFormatter } from '../formatters/spotify_discovery';

export const spotifyDiscoveryActions = {
	getSpotifyDiscovery,
	getSpotifyDiscoveryTotals,
	getSpotifyDiscoveryTimeseries,
	getSpotifyDiscoveryMainTimeseries,
	getSpotifyDiscoveryDetailsTimeseries,
	resetSpotifyDiscoveryDetailsTimeseries
};

const cleanUpParams = (params) => {
	return {
		dateStart: params.dateStart, 
		dateEnd: params.dateEnd, 
		prevDateStart: params.prevDateStart, 
		prevDateEnd: params.prevDateEnd, 
		range: params.range, 
		limit: params.limit
	}
}


function getSpotifyDiscovery(params, useCache = true) {
	return (dispatch, getState) => {
		
		const globalFilter = getState().filter.global;
		params = {
			...cleanUpParams(globalFilter),
			range: params.range,
			artists: params.track_artists
		};
		
		const data = useCache ? getState().spotifyDiscovery.data : undefined;
		if(data!==undefined) {
			
			dispatch(success(data));
			return data;
		}
		
		
		dispatch(request());

		return spotifyDiscoveryService.getSpotifyDiscovery(params)
			.then(
				spotifyDiscovery => {
					let data = spotifyDiscoveryFormatter.formatSpotifyDiscoveryFlat(spotifyDiscovery);
					const ids = map(data, 'track_id');
					return tracksService.getMetadata(ids)
					.then(metadata => {
						const tracks = spotifyDiscoveryFormatter.formatMetadata(data, metadata.data);
						dispatch(success(tracks));	
						return tracks;
					}); 

					
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_REQUEST } }
	function success(data) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_SUCCESS, data } }
	function failure(error) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_FAILURE, error } }
}

function getSpotifyDiscoveryTotals(params, useCache = true) {
	return (dispatch, getState) => {
		
		const totals = useCache ? getState().spotifyDiscovery.totals : undefined;
		if(totals!==undefined) {
			
			dispatch(success(totals));
			return totals;
		}
		
		
		
		dispatch(request());
		const globalFilter = getState().filter.global;
		params = {
			...cleanUpParams(globalFilter),
			range: 'mth',
			artists: params.track_artists
		};

		return spotifyDiscoveryService.getSpotifyDiscoveryTotals(params)
			.then(
				spotifyDiscovery => {
					let data = spotifyDiscoveryFormatter.formatSpotifyDiscoveryTotals(spotifyDiscovery);
					dispatch(success(data));	
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TOTALS_REQUEST } }
	function success(data) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TOTALS_SUCCESS, data } }
	function failure(error) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TOTALS_FAILURE, error } }
}

function getSpotifyDiscoveryTimeseries(params, useCache = true) {
	return (dispatch, getState) => {
		
		const timeseries = useCache ? getState().spotifyDiscovery.timeseries : undefined;
		if(timeseries!==undefined) {
			
			dispatch(success(timeseries));
			return timeseries;
		}
		
		
		dispatch(request());
		
		const globalFilter = getState().filter.global;
		params = {
			...cleanUpParams(globalFilter),
			range: params.range,
			artists: params.track_artists
		};

		return spotifyDiscoveryService.getSpotifyDiscoveryTimeseries(params)
			.then(
				spotifyDiscovery => {
					let data = spotifyDiscoveryFormatter.formatSpotifyDiscoveryTimeseries(spotifyDiscovery);
					dispatch(success(data));	
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TIMESERIES_REQUEST } }
	function success(data) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TIMESERIES_SUCCESS, data } }
	function failure(error) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_TIMESERIES_FAILURE, error } }
}

function getSpotifyDiscoveryMainTimeseries(params, useCache = true) {
	return (dispatch, getState) => {
		const timeseries = useCache ? getState().spotifyDiscovery.details : undefined;
		if(timeseries!==undefined) {
			
			dispatch(success(timeseries));
			return timeseries;
		}
		
		

		dispatch(request());
		const globalFilter = getState().filter.global;
		params = {
			...cleanUpParams(globalFilter),
			range: params.range,
			artists: params.track_artists
		};

		return spotifyDiscoveryService.getSpotifyDiscoveryMainTimeseries(params)
			.then(
				details => {
					const ids = uniq(map(details, 'track_id'));
					return tracksService.getMetadata(ids)
					.then(metadata => {
						details = spotifyDiscoveryFormatter.formatSpotifyDiscoveryMainTimeseries(details, metadata.data);
						dispatch(success(details));	
						return details;
					});
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_REQUEST } }
	function success(data) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_SUCCESS, data } }
	function failure(error) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_MAIN_TIMESERIES_FAILURE, error } }
}

function getSpotifyDiscoveryDetailsTimeseries(params) {
	return (dispatch, getState) => {
		dispatch(request());
		params.tracks = params.id;
		delete params.id;
		return spotifyDiscoveryService.getSpotifyDiscoveryDetailsTimeseries(params)
			.then(
				spotifyDiscovery => {
					let data = spotifyDiscoveryFormatter.formatSpotifyDiscoveryDetailsTimeseries(spotifyDiscovery);
					dispatch(success(data));	
					return data;
				},
				error => {
					dispatch(failure('error'))
				}
			);
	};

	function request() { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_REQUEST } }
	function success(data) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_SUCCESS, data } }
	function failure(error) { return { type: spotifyDiscoveryConstants.GET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES_FAILURE, error } }
}

function resetSpotifyDiscoveryDetailsTimeseries(params) {
	return (dispatch, getState) => {
		dispatch(reset());
	};

	function reset() { return { type: spotifyDiscoveryConstants.RESET_SPOTIFY_DISCOVERY_DETAILS_TIMESERIES } }
}
